export class Connection {
  user_id: string;
  ffl: string;
  company_id: string;
}

export const WebsocketRoutes = {
  add_new_service: 'add_new_service',
  add_new_product: 'add_new_product',
  
};
